
import React from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { RegisterFormValues } from "@/types/auth";

interface PersonalInfoFieldsProps {
  form: UseFormReturn<RegisterFormValues>;
}

export const PersonalInfoFields = ({ form }: PersonalInfoFieldsProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="first_name"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-black">First Name</FormLabel>
            <FormControl>
              <Input 
                id="first_name" 
                placeholder="First Name" 
                {...field} 
                className="bg-white border-gray-200" 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="last_name"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-black">Last Name</FormLabel>
            <FormControl>
              <Input placeholder="Last Name" {...field} className="bg-white border-gray-200" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-black">Email</FormLabel>
            <FormControl>
              <Input 
                type="email"
                placeholder="Email Address" 
                {...field} 
                className="bg-white border-gray-200" 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="mobile_number"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-black">Phone</FormLabel>
            <FormControl>
              <Input 
                placeholder="+1 (555) 555-5555" 
                {...field} 
                className="bg-white border-gray-200" 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
